import React, { useEffect } from "react";
import AboutSection from "../components/AboutSection";
import ProjectSection from "../components/ProjectSection";
import FaqSection from "../components/FaqSection";
import BlogSection from "../components/BlogSection";
import { motion } from "framer-motion";
import pageAnimation from "../pageAnimation";
import Skill from "../components/Skills";

export default function Aboutme() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <motion.div
      variants={pageAnimation}
      initial="before"
      animate="after"
      exit="exit"
    >
      <AboutSection />
      <Skill />
      <ProjectSection />
      <BlogSection />
      <FaqSection />
    </motion.div>
  );
}
